module.exports = __webpack_public_path__ + "img/young-m6c.165254c4.png";